export class DialogModelAddMed{
    constructor(
      public data:any
    ) {}
  }